module.exports = __webpack_public_path__ + "static/img/qrcode.88814332.jpg";